import { render, staticRenderFns } from "./shopGiftDetails.vue?vue&type=template&id=6586fef2&scoped=true&"
import script from "./shopGiftDetails.vue?vue&type=script&lang=js&"
export * from "./shopGiftDetails.vue?vue&type=script&lang=js&"
import style0 from "./shopGiftDetails.vue?vue&type=style&index=0&id=6586fef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586fef2",
  null
  
)

export default component.exports